module.exports = "<div class=\"subscribe_result\" id=\"subscribe_error\" [@resultState]=\"state\" (@resultState.done)=\"hide()\">\n    <div class=\"subscribe_res_text_container\">\n        <p id=\"error_message\">\n            {{errorMessage}}\n        </p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subscribe-result-error/subscribe-result-error.component.html
// module id = ./src/app/components/subscribe-result-error/subscribe-result-error.component.html
// module chunks = main